import { Grid } from "@mui/material";
import React from "react";
import { PrimaryButton, SecondaryButton } from "../Buttons";

const FormButtons = (props) => {
  const { back, click } = props;
  return (
    <>
      <Grid container spacing={2} marginTop="1rem" className="form-buttons">
        <Grid item lg={6} width="50%">
          <SecondaryButton
            click={back}
            width="100%"
            textTransform="capitalize"
          />
        </Grid>
        <Grid item lg={6} width="50%">
          <PrimaryButton
            click={click}
            width="100%"
            fullWidth={true}
            textTransform="capitalize"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormButtons;
